var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notFound"},[_c('img',{attrs:{"src":_vm.defaultUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }